import * as Type from './actionsTypes';

const INITIAL_STATE = {
  programacaoDiarias: [],
  selectedProgramacaoDiaria: null,
  options: [],
};

const ordernarData = (a, b) => {
  return Number(a.data) > Number(b.data);
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case Type.FETCH_PROGRAMACAO_DIARIAS_SUCCESS: {
      return {
        ...state,
        programacaoDiarias: action.data.sort(ordernarData)
      }
    }
    case Type.DELETE_PROGRAMACAO_DIARIA_SUCCESS: {
      return {
        ...state,
        programacaoDiarias: state.programacaoDiarias.filter(s => s.id !== action.data).sort(ordernarData)
      }
    }
    case Type.SAVE_PROGRAMACAO_DIARIA_SUCCESS: {
      return {
        ...state,
        programacaoDiarias: [...state.programacaoDiarias, action.data].sort(ordernarData)
      }
    }
    case Type.UPDATE_PROGRAMACAO_DIARIA_SUCCESS: {
      return {
        ...state,
        programacaoDiarias: [...state.programacaoDiarias.filter(s => s.id !== action.data.id), action.data].sort(ordernarData)
      }
    }
    case Type.PROGRAMACAO_DIARIA_FIND_BY_ID_SUCCESS: {
      return {
        ...state,
        selectedProgramacaoDiaria: action.data
      }
    }
    case Type.PROGRAMACAO_DIARIA_VALIDATE_BY_ID_SUCCESS: {
      const programacaoDiaria = state.programacaoDiarias.filter(s => s.id === action.id)[0];
      programacaoDiaria.validate = action.validate;
      return {
        ...state,
        programacaoDiarias: [...state.programacaoDiarias.filter(s => s.id !== action.id), programacaoDiaria].sort(ordernarData)
      }
    }
    case Type.PROGRAMACAO_DIARIA_FIND_OPTIONS_SUCCESS: {
      return {
        ...state,
        options: action.data
      }
    }
    case Type.CLEAR_PROGRAMACAO_DIARIA: {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
}

export const getProgramacaoDiarias = state => state.rootState.programacaoDiaria.programacaoDiarias;
export const getSelectedProgramacaoDiaria = state => state.rootState.programacaoDiaria.selectedProgramacaoDiaria;
export const getProgramacaoDiariasOptions = state => state.rootState.programacaoDiaria.options;
